import React, { useState } from "react";

import Updates from "./Update";
import "./RightSide.css";
import { toast } from "react-toastify";
// import CustomerReview from "./CustomerReview";

const RightSide = () => {
  const [refreshSmsKey, setRefreshSmsKey] = useState(0);

  const handleSmsSent = (results) => {
    // Trigger SMS logs refresh by updating key
    setRefreshSmsKey((prev) => prev + 1);
    toast.success(
      `SMS sent! ${results.successful} successful, ${results.failed} failed`
    );
  };
  return (
    <div className="RightSide">
      <div>
        <h3 className="textcent">Updates</h3>
        {/* Right sidebar */}
        <div className="sidebar">
          <Updates key={`updates-${refreshSmsKey}`} />
        </div>
      </div>
      {/* <div>
        <h3>Customer Review</h3>
        <CustomerReview />
      </div> */}
    </div>
  );
};

export default RightSide;
